import React, { FC, PropsWithChildren } from 'react'

/**
 * @param components array of context providers to be combined from left to right
 * @returns Functional component
 */
export const combineComponents = (...components: FC[]) => {
    const CombinedComponent: FC<PropsWithChildren<object>> = ({ children }) => {
        return (
            <>
                {components.reduceRight((AccumulatedComponents, CurrentComponent: FC<PropsWithChildren<object>>) => {
                    return <CurrentComponent>{AccumulatedComponents}</CurrentComponent>
                }, children)}
            </>
        )
    }

    CombinedComponent.displayName = 'CombinedComponent'

    return CombinedComponent
}
